module.exports = __webpack_public_path__ + "static/icon-pledge-4-9335778c2e9f3e9aec9cb0f83944cede.svg";